<template>
  <Notifications>
    <template #default="{ notifies, errors }">
      <Dropdown placement="bottom" auto-boundary-max-size>
        <template #default="{ toggle }">
          <div class="main-desktop-header-button">
            <NotificationsIcon
              class="main-desktop-header-icon"
              @click="toggle"
            />
          </div>
        </template>
        <template #popper="{ hide }">
          <AppNotifications
            :notifies
            :errors
            @click:item="hide"
          />
        </template>
      </Dropdown>
    </template>
  </Notifications>
</template>

<script setup lang="ts">
import { Dropdown } from 'floating-vue'

import Notifications from '../../components/Notifications.vue'
import NotificationsIcon from '../../components/NotificationsIcon.vue'
import { AppNotifications } from '@app'
</script>
